require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-aye-robot-how-high-tech-changes-assembly-line.json") })
        }
      }, "path---blog-aye-robot-how-high-tech-changes-assembly-line");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-aye-robot-how-high-tech-changes-assembly-line!./.cache/json/blog-aye-robot-how-high-tech-changes-assembly-line.json
// module id = 714
// module chunks = 231608221292675